import React from 'react'
import NavDrawer from './navDrawer/NavDrawer'
import CodeIcon from '@mui/icons-material/Code';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import RateReviewIcon from '@mui/icons-material/RateReview';
import AssignmentIcon from '@mui/icons-material/Assignment';
import AssessmentIcon from '@mui/icons-material/Assessment';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import NoteAltIcon from '@mui/icons-material/NoteAlt';
import PieChartIcon from '@mui/icons-material/PieChart';
import TimelineIcon from '@mui/icons-material/Timeline';

function MentorDashboard() {
    const menuItems = [
        { label: 'Lab Practice', icon: <CodeIcon />, path: '/mentor/lab-practice' },
        { label: 'Attendance', icon: <HowToRegIcon />, path: '/mentor/attendance' },
        { label: 'Learner Reviews', icon: <RateReviewIcon />, path: '/mentor/learner-reviews' },
        { label: 'Learner Practices', icon: <AssignmentIcon />, path: '/mentor/learner-practices' },
        { label: 'Daily Report', icon: <AssessmentIcon />, path: '/mentor/daily-report' },
        { label: 'Daily Practice', icon: <AssignmentTurnedInIcon />, path: '/mentor/daily-practice' },
        { label: 'Practice Notes', icon: <NoteAltIcon />, path: '/mentor/practice-notes' },
        { label: 'Coder Distribution', icon: <PieChartIcon />, path: '/mentor/coder-distribution' },
        { label: 'Track', icon: <TimelineIcon />, path: '/mentor/learners' },
    ];
  return (
    <div>
        <NavDrawer menuItems={menuItems}/>
    </div>
  )
}

export default MentorDashboard